"use client"

import { Switch as BaseSwitch } from "@base-ui/react/switch"
import Spinner from "@src/components/Spinner"
import clsx from "clsx"

interface SwitchProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  isLoading?: boolean
  "aria-label"?: string
}

const Switch = ({
  checked,
  onCheckedChange,
  disabled,
  isLoading,
  "aria-label": ariaLabel,
}: SwitchProps) => {
  return (
    <BaseSwitch.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={ariaLabel}
      className={clsx(
        "group relative inset-ring inset-ring-gray-900/5 flex h-6 w-13 cursor-pointer rounded-lg bg-gray-300 confidential:bg-gray-600 p-[3px] outline-gray-900 outline-offset-2 transition-colors duration-200 ease-in-out focus-visible:confidential:outline-white focus-visible:outline-2",

        "data-disabled:cursor-not-allowed data-disabled:opacity-50",

        "confidential:data-checked:bg-green-600 data-checked:bg-green-600"
      )}
    >
      <BaseSwitch.Thumb className="pointer-events-none inline-flex h-4.5 w-6 translate-x-0 items-center justify-center rounded-md bg-white ring-0 transition duration-200 ease-in-out data-checked:translate-x-5.5">
        {isLoading && <Spinner className="text-gray-400" size="xs" />}
      </BaseSwitch.Thumb>
    </BaseSwitch.Root>
  )
}

export default Switch
